import {faTimes} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Label} from '@freckle/educator-materials/ts/components/label'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {filter, label, filterValue, link} from './filter.module.scss'

type Props = {
  name: string
  url: string
}

export default function Filter(props: Props) {
  const {url, name} = props
  const {t} = useSafeTranslation()

  return (
    <div className={filter}>
      <Label className={label}>{t('MANAGE_TEACHERS_FILTER_FILTER_LABEL')}</Label>
      <span className={filterValue}>{name}</span>
      <Link
        className={link}
        href={url}
        reactRouter
        title={t('MANAGE_TEACHERS_FILTER_REMOVE_FILTER_LINK_TITLE')}
      >
        <FontAwesomeIcon icon={faTimes} />
      </Link>
    </div>
  )
}
